<template>
	<div>
		<el-tabs v-model="activeName" type="border-card">
			<el-tab-pane label="信息" name="first"></el-tab-pane>
			<el-tab-pane label="日志" name="second"></el-tab-pane>
			<el-descriptions v-if="activeName === 'first'" :column="1" border>
				<el-descriptions-item>
					<template slot="label">工号：</template>
					{{userInfo.agentCode}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">分机：</template>
					{{userInfo.deviceCode}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">状态：</template>
					<span>{{StoreIsBusyReason ? StoreIsBusyReason : StoreIsSignIn ? '置忙' : ''}}</span>
				</el-descriptions-item>
			</el-descriptions>
			<div v-else class="in_msg">
				<div v-for="(item, index) in StoreSoftPhoneInMsg" :key="index" style="margin-top: 8px;">{{item}}</div>
			</div>
		</el-tabs>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters([
			'userInfo',
			'StoreSoftPhoneInMsg',
			'StoreIsIdle',
			'StoreIsBusy',
			'StoreIsSignIn',
			'StoreIsBusyReason', // ~ 置闲 / 置忙原因
		])
	},
	data() {
		return {
			activeName: 'first'
		}
	}
}
</script>

<style lang="scss" scoped>
.in_msg {
	border: 1px solid #DCDFE6;
	padding: 10px;
	height: 200px;
	overflow-x: hidden;
	overflow-y: auto;
}
</style>